// extracted by mini-css-extract-plugin
export default {"newIcon":"MovieFlags_newIcon__350Yy","reducedIcon":"MovieFlags_reducedIcon__Ij1qI","audioVipTop100Section":"MovieFlags_audioVipTop100Section__iBmAf","flag":"MovieFlags_flag__1b1-E"};